import { PALETTE } from '../../common/styles/palette';
export const styles = (theme?: any) => {
    return {
        paper: {
            borderRadius: '8px',
            padding: '0px',
            flexWrap: 'wrap' as any,
            width: '100%'
        },
        titleHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            paddingRight: '7px',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            backgroundColor: PALETTE.Primary,
            paddingLeft: '10px',
            paddingTop: '10px',
            paddingBottom: '10px',
            color: 'white',
            marginBottom: '10px',
            alignItems: 'center'
        },
        fullHeight: {
            height: 'calc(100% - 0px)'
        },
        fullHeightContent: {
            height: 'calc(100% - 38px)'
        },
        scrollable: {
            overflow: 'auto'
        },
        flex: {
            display: 'flex'
        }
    }
}